var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('WeedMusic',{attrs:{"msg":"WeedMusic","des":"A Symphony for your high "}}),_c('music',{attrs:{"music":_vm.music}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }